/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/DesignSystem/AppointmentHistory/Content/Entry/Action"
  
}) {
let entryActionValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'action',
})
let entryBookingDatetimeValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'booking_datetime',
})
let aggregateData = fromHelpers.getTitle(entryActionValueData, entryBookingDatetimeValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 weight="medium"
 whiteSpace="wrap"
 data="entry.action"
 data="entry.booking_datetime"
 aggregate="helpers.js getTitle"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}